__turbopack_context__.v({
  "widgetScrollbar": "tTsKvq_widgetScrollbar",
});
